import MedicalCard from "./MedicalCard";
export default MedicalCard;